export default "__VITE_ASSET__23ed0583__"